import { useEffect } from 'react';

import { trackEvent } from 'utils/analytics/track/trackEvent';

const INTERVAL_MS_TO_CONSIDER_A_COMPLETE_SEARCH = 2_000;

type Args = {
  query: string;
};

export function useTrackTileGridSearch({ query }: Args) {
  useEffect(() => {
    if (!query) return undefined;

    const timeout = setTimeout(() => {
      trackEvent('Tile Grid Search', { query });
    }, INTERVAL_MS_TO_CONSIDER_A_COMPLETE_SEARCH);

    return () => {
      clearTimeout(timeout);
    };
  }, [query]);
}
